import { leadsHandoffScope } from './routeHandoff.js';

export function clientLanding(capabilities = [], portfolio = false) {
  if (portfolio && capabilities.includes('view_dashboard')) return '/home';
  if (capabilities.some(c => ['view_stats', 'view_ad_metrics'].includes(c))) return '/performance';
  if (capabilities.includes('view_magnets')) return '/leads';
  if (capabilities.includes('connect_ad_accounts')) return '/ad-accounts';
  return '/settings/workspace';
}

let reportPeriod;
export function setPerformancePeriod(route, days) {
  reportPeriod = { route, days, scope: JSON.stringify(leadsHandoffScope()) };
}
export function takePerformancePeriod(route, fallback = 30) {
  if (!reportPeriod || reportPeriod.route !== route) return fallback;
  const pending = reportPeriod;
  reportPeriod = null;
  return pending.scope === JSON.stringify(leadsHandoffScope()) && [7,30,90].includes(pending.days) ? pending.days : fallback;
}
